import { Suspense } from "react";
import { createBrowserRouter } from "react-router-dom";
import ProtectedRoute from "./protectedRoute";
import Layout from "../components/layout";
import ProvidersList from "../pages/providers";
import Login from "../pages/Login";
import { Header } from "../components/Header";
import AddProvidersSteps from "../pages/providers/AddProviders";
import { PriceListTable } from "../pages/providers/AddProviders/Prices/PriceListTable";
import RequestsList from "../pages/Requests";
import { ViewRequest } from "../pages/Requests/viewRequests";
import AddRequestSteps from "../pages/Requests/AddRequest";
import { Dashboard } from "../pages/Dashboard";
import { ViewResult } from "../pages/Requests/viewRequests/ViewResult";
import CompaniesList from "../pages/Sponsors";
import AddCompaniesSteps from "../pages/Sponsors/AddSponors";
import CustomersList from "../pages/Customers";
import ReportsPage from "../pages/Reports";
import SentCodesPage from "../pages/SentCodes";
import NotificationTestPage from "../pages/NotificationTest";

// const user = {
//   isAuthenticated: true,
//   roles: ["admin"], // Example user roles
// };

const isAuthenticated = localStorage.getItem("token");

const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <ProtectedRoute
        isAuthenticated={!!isAuthenticated}
        requiredRoles={[]}
        userRoles={[]}
        component={() => (
          <Suspense fallback={<div>Loading...</div>}>
            <Layout />
          </Suspense>
        )}
      />
    ),

    errorElement: <>Error</>,
    children: [
      {
        id: "provider",
        path: "providers",
        element: (
          <ProtectedRoute
            isAuthenticated={!!isAuthenticated}
            requiredRoles={[]}
            userRoles={[]}
            component={() => (
              <Suspense fallback={<div>Loading...</div>}>
                <ProvidersList />
              </Suspense>
            )}
          />
        ),
      },
      {
        id: "add-provider",
        path: "add-provider/:id?",
        element: (
          <ProtectedRoute
            isAuthenticated={!!isAuthenticated}
            requiredRoles={[]}
            userRoles={[]}
            component={() => (
              <Suspense fallback={<div>Loading...</div>}>
                <AddProvidersSteps />
              </Suspense>
            )}
          />
        ),
      },
      {
        id: "provider-price-list",
        path: "providers/:providerId/list/:serviceId",
        element: (
          <ProtectedRoute
            isAuthenticated={!!isAuthenticated}
            requiredRoles={[]}
            userRoles={[]}
            component={() => (
              <Suspense fallback={<div>Loading...</div>}>
                <PriceListTable />
              </Suspense>
            )}
          />
        ),
      },
      {
        id: "view-request",
        path: "request/:requestId",
        element: (
          <ProtectedRoute
            isAuthenticated={!!isAuthenticated}
            requiredRoles={[]}
            userRoles={[]}
            component={() => (
              <Suspense fallback={<div>Loading...</div>}>
                <ViewRequest />
              </Suspense>
            )}
          />
        ),
      },
      {
        id: "sponsor",
        path: "sponsors",
        element: (
          <ProtectedRoute
            isAuthenticated={!!isAuthenticated}
            requiredRoles={[]}
            userRoles={[]}
            component={() => (
              <Suspense fallback={<div>Loading...</div>}>
                <Header title="Sponsors" />
              </Suspense>
            )}
          />
        ),
      },
      {
        id: "request",
        path: "requests",
        element: (
          <ProtectedRoute
            isAuthenticated={!!isAuthenticated}
            requiredRoles={[]}
            userRoles={[]}
            component={() => (
              <Suspense fallback={<div>Loading...</div>}>
                <RequestsList />
              </Suspense>
            )}
          />
        ),
      },
      {
        id: "requests-approvals",
        path: "approvals",
        element: (
          <ProtectedRoute
            isAuthenticated={!!isAuthenticated}
            requiredRoles={[]}
            userRoles={[]}
            component={() => (
              <Suspense fallback={<div>Loading...</div>}>
                <RequestsList isApprovalPage />
              </Suspense>
            )}
          />
        ),
      },
      {
        id: "add-request",
        path: "add-request/:requestId?",
        element: (
          <ProtectedRoute
            isAuthenticated={!!isAuthenticated}
            requiredRoles={[]}
            userRoles={[]}
            component={() => (
              <Suspense fallback={<div>Loading...</div>}>
                <AddRequestSteps />
              </Suspense>
            )}
          />
        ),
      },
      {
        id: "dashboard",
        path: "dashboard",
        element: (
          <ProtectedRoute
            isAuthenticated={!!isAuthenticated}
            requiredRoles={[]}
            userRoles={[]}
            component={() => (
              <Suspense fallback={<div>Loading...</div>}>
                <Dashboard />
              </Suspense>
            )}
          />
        ),
      },
      {
        id: "results",
        path: "view-results-request/:requestId?",
        element: (
          <ProtectedRoute
            isAuthenticated={!!isAuthenticated}
            requiredRoles={[]}
            userRoles={[]}
            component={() => (
              <Suspense fallback={<div>Loading...</div>}>
                <ViewResult />
              </Suspense>
            )}
          />
        ),
      },
      {
        id: "client",
        path: "clients",
        element: (
          <ProtectedRoute
            isAuthenticated={!!isAuthenticated}
            requiredRoles={[]}
            userRoles={[]}
            component={() => (
              <Suspense fallback={<div>Loading...</div>}>
                <CustomersList />
              </Suspense>
            )}
          />
        ),
      },
      {
        id: "service",
        path: "services",
        element: (
          <ProtectedRoute
            isAuthenticated={!!isAuthenticated}
            requiredRoles={[]}
            userRoles={[]}
            component={() => (
              <Suspense fallback={<div>Loading...</div>}>
                <Header title="Services" />
              </Suspense>
            )}
          />
        ),
      },
      {
        id: "req-services",
        path: "request-results",
        element: (
          <ProtectedRoute
            isAuthenticated={!!isAuthenticated}
            requiredRoles={[]}
            userRoles={[]}
            component={() => (
              <Suspense fallback={<div>Loading...</div>}>
                <RequestsList isResults />
              </Suspense>
            )}
          />
        ),
      },
      {
        id: "companies",
        path: "companies",
        element: (
          <ProtectedRoute
            isAuthenticated={!!isAuthenticated}
            requiredRoles={[]}
            userRoles={[]}
            component={() => (
              <Suspense fallback={<div>Loading...</div>}>
                <CompaniesList />
              </Suspense>
            )}
          />
        ),
      },
      {
        id: "add-company",
        path: "add-company/:id?",
        element: (
          <ProtectedRoute
            isAuthenticated={!!isAuthenticated}
            requiredRoles={[]}
            userRoles={[]}
            component={() => (
              <Suspense fallback={<div>Loading...</div>}>
                <AddCompaniesSteps />
              </Suspense>
            )}
          />
        ),
      },
      {
        id: "reports",
        path: "reports",
        element: (
          <ProtectedRoute
            isAuthenticated={!!isAuthenticated}
            requiredRoles={[]}
            userRoles={[]}
            component={() => (
              <Suspense fallback={<div>Loading...</div>}>
                <ReportsPage />
              </Suspense>
            )}
          />
        ),
      },
      {
        id: "sent-codes",
        path: "sent-codes",
        element: (
          <ProtectedRoute
            isAuthenticated={!!isAuthenticated}
            requiredRoles={[]}
            userRoles={[]}
            component={() => (
              <Suspense fallback={<div>Loading...</div>}>
                <SentCodesPage />
              </Suspense>
            )}
          />
        ),
      },
      {
        id: "notification-test",
        path: "notification-test",
        element: (
          <ProtectedRoute
            isAuthenticated={!!isAuthenticated}
            requiredRoles={[]}
            userRoles={[]}
            component={() => (
              <Suspense fallback={<div>Loading...</div>}>
                <NotificationTestPage />
              </Suspense>
            )}
          />
        ),
      },
    ],
  },
  {
    path: "login",
    element: <Suspense fallback={<div>Loading...</div>}>{<Login />}</Suspense>,
  },
]);

export default router;
